import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ApiService } from 'src/app/services/api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import moment from 'moment';
import { CUSTOMER_TYPE_FAILURE_MSG, ERROR_PLEASE_TRY_AGAIN } from '../../../models/Constants';
import { MatDialog } from '@angular/material/dialog';


/** 
* added code to format date in text box- e.g - May-30-2023. .
* @author :Amarjeet Kumar
*/
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'app-create-alert',
  templateUrl: './create-alert.component.html',
  styleUrls: ['./create-alert.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class CreateAlertComponent {

  constructor(public apiService: ApiService,
    public rootScope: RootScopeService,
    public dialog: MatDialog) {
    this.checkData();
  }

  /** 
* createAlertForm -- holding entire create Alert form field value, required validation & default date assignment .
* @author :Amarjeet Kumar
*/
  createAlertForm = new FormGroup({
    alertType: new FormControl('', Validators.required),
    alertSubType: new FormControl('', Validators.required),
    // CCR3-11480 title & description field validation to not allow the tags.
    title: new FormControl('', [Validators.required,Validators.pattern(Constants.REGEX.tags)]),
    description: new FormControl('', [Validators.required,Validators.pattern(Constants.REGEX.tags)]),
    start: new FormControl<Date | null>(new Date(), Validators.required),
    end: new FormControl<Date | null>(null, Validators.required),
  });

 


  maxDate!: Date;
  minDate = this.createAlertForm.value.start;
  todayDate: Date = new Date();
  alertTypes: any = [];
  alertSubTypes: any = [];
  alertTypesErrMsg = CUSTOMER_TYPE_FAILURE_MSG;
  createAlertErrMsg = ERROR_PLEASE_TRY_AGAIN;
  isCreateAPIError: boolean = false;
  isAlertTypesAPIError: boolean = false;
  loaderType = Constants.LOADER_TYPE.CARD;
  showLoader: boolean = false;
  subTypeDetails: any;
  @Input() autofocus: boolean = true; 
  charLength = 0;
  panelId: string = '';
  /** 
* Date validation -- Added code to validate End Date should be larger than Start Date .
* @author :Amarjeet Kumar
*/
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.createAlertForm.value.start;
  }

  /** 
 * checkData -- checking for cached data.
 * @author :Amarjeet Kumar
 */
  checkData() {
    if (this.rootScope.alertTypesDataMap[this.rootScope.activeCustTab.customerSessionId])
      this.alertTypes = this.rootScope.alertTypesDataMap[this.rootScope.activeCustTab.customerSessionId]?.data?.alertConfiguration;
    else {
      this.getAlertTypes();
      
    }
    if ( !this.rootScope.panelIdList.get(this.rootScope.activeCustTab.customerSessionId)) {
      this.apiService.getCustomerPanelId();
      this.rootScope.panelIdList.set(this.rootScope.activeCustTab.customerSessionId,true)
    }
    
  }


  /** 
 * getAlertTypes -- calling API to get Alert Types.
 * @author :Amarjeet Kumar
 */
  getAlertTypes() {
    this.showLoader = true;
    this.apiService.getAlertTypes(this.rootScope.activeCustTab.clientId).subscribe({
      next: (data: any) => {
        this.alertTypes = data.data.alertConfiguration;
        this.rootScope.alertTypesDataMap[this.rootScope.activeCustTab.customerSessionId] = data;
        this.isAlertTypesAPIError = false;
        this.showLoader = false;
      },
      error: (error) => {
        this.isAlertTypesAPIError = true;
        this.showLoader = false;
      },

    })
  }


  /** 
 * subTypeAlerts -- setting Sub Alerts types list After Alert selection.
 * @author :Amarjeet Kumar
 */
  subTypeAlerts(data: any, event: any) {
    if (event?.isUserInput) {
      this.alertSubTypes = data?.subtypeConfigurations;

      if (this.createAlertForm.get('alertType')?.value != data?.type) {
        this.createAlertForm.reset();
        this.createAlertForm.get('start')?.setValue(new Date());
      }
    }
    this.charLength = this.createAlertForm.get('description')?.value?.length || 0;
  }


  /** 
 * alertSubTypeSelection -- setting title & details After Sub Alert type selection.
 * @author :Amarjeet Kumar
 */
  alertSubTypeSelection(data: any, event: any) {
    if (event?.isUserInput) {
      this.subTypeDetails = data;
      this.createAlertForm
        .get('title')
        ?.setValue(data?.alertConfigDetails?.title);
      this.createAlertForm
        .get('description')
        ?.setValue(data?.alertConfigDetails?.details);
    }
     this.charLength = this.createAlertForm.get('description')?.value?.length || 0;
  }


  /** 
 * onSubmit -- setting create object & calling create API to create alert.
 * @author :Amarjeet Kumar
 */
  onSubmit() {

    let createAlert: any = {
      subject: {
        id: this.rootScope.activeCustTab.id,
        lastName: this.rootScope.activeCustTab?.tabData?.tabData?.lastName,
        firstName: this.rootScope.activeCustTab?.tabData?.tabData?.firstName,
        type: this.rootScope.activeCustTab?.roleType
      },
      clientId: this.rootScope.activeCustTab?.clientId,
      begin: moment(this.createAlertForm.value.start).year() + '-' + (moment(this.createAlertForm.value.start).month() + 1).toString().padStart(2, '0') + '-' + moment(this.createAlertForm.value.start).date().toString().padStart(2, '0') + "T00:00:00.000Z",
      end: moment(this.createAlertForm.value.end).year() + '-' + (moment(this.createAlertForm.value.end).month() + 1).toString().padStart(2, '0') + '-' + moment(this.createAlertForm.value.end).date().toString().padStart(2, '0') + "T23:59:00.000Z",
      channel: this.rootScope.activeCustTab?.channel,
      system: Constants.SYSTEM_NAME,
      secured: this.subTypeDetails?.alertConfigDetails?.secured,
      creator: {
        //name: this.rootScope.firstName + ' ' + this.rootScope.lastName, CCR3-11480 Penetration Testing Fix
        id: this.rootScope.lanId ? this.rootScope.lanId : sessionStorage.getItem('lanId'),
        emailAddress: this.rootScope?.emailId ? this.rootScope?.emailId : sessionStorage.getItem('emailId')
      },
      description: this.createAlertForm.value.title,
      details: this.createAlertForm.value.description,
      externalRefId: this.rootScope.activeCustTab?.tabData?.tabData?.externalRefId,
      manualAlertType: this.createAlertForm.value.alertType, 
      manualAlertSubType: this.createAlertForm.value.alertSubType,
      panelId: this.panelId
    }
    /*istanbul ignore next */
    this.apiService.creatAlerts(createAlert).subscribe({
      next: (data: any) => {
        console.log(data);
        this.isCreateAPIError = false;
        this.rootScope.isAlertAdded = true;
        let alertId = data?.message.split(":");
        this.rootScope.newAlertId = alertId[1].trim();
        this.dialog.closeAll();
        this.rootScope.openCreateAlertDialog = false;
        this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog', false]);
        this.rootScope.panelIdList.delete(this.rootScope.activeCustTab.customerSessionId);

      },
      error: (error) => {
        this.isCreateAPIError = true;
      },

    })
  }

  closeCreateAlert() {
    this.apiService.getCustomerPanelId();
        this.rootScope.openCreateAlertDialog = false;
    this.rootScope.accountModalPopup.set(this.rootScope.activeCustTab.customerSessionId, ['openCreateAlertDialog', false]);
    this.rootScope.panelIdList.delete(this.rootScope.activeCustTab.customerSessionId);
  }

  onTextareaChanged(event: any) {
    const raw: string = (event?.detail?.value ?? event?.target?.value ?? '');
    let normalized = raw.replace(/[\r\n]/g, ''); //removes all the line breaks
      if (normalized.length > 1000) {
        normalized = normalized.substring(0, 1000);
        }
      const descriptionControl = this.createAlertForm.get('description');
      if (descriptionControl) {
        const currentValue: string = descriptionControl.value ?? '';
        if (currentValue !== normalized) {
          descriptionControl.setValue(normalized);
        }
      }
      this.charLength = normalized.length;
}
}
